import gql from 'graphql-tag';

/**
 * 获取积分商品列表
 */
export const fetchGetPointsProductsDocument = gql`
  query getPointsProducts($isAllowExchange: Boolean, $options: PointsProductListOptions) {
    getPointsProducts(isAllowExchange: $isAllowExchange, options: $options) {
      items {
        allowPurchaseAtOriginalPrice
        exchangeConditionType
        pointExchange {
          points
          cash
          exchangeTotal
        }
        product {
          id
          name
          enabled
          productTotalStock
          featuredAsset {
            source
          }
          customFields {
            price
            markingPrice
            limitType
            limitCount
            putOnSaleType
            putOnSaleTime
            isVipProduct
            isHiddenCart
            virtualTargetType
          }
        }
      }
      totalItems
    }
  }
`;

/**
 * 获取积分明细
 */
export const fetchPointsHistoryDocument = gql`
  query pointsHistory($options: PointsHistoryListOptions) {
    pointsHistory(options: $options) {
      items {
        id
        createdAt
        points
        sourceId
        sourceType
        description
        symbolType
      }
      totalItems
    }
  }
`;

/**
 * 获取积分规则
 */
export const fetchPointsConfigDocument = gql`
  query pointsConfig {
    pointsConfig {
      pointsRuleText
    }
  }
`;

/**
 * 获取积分商品已兑换数量
 */
export const fetchGetExchangeableQuantityDocument = gql`
  query getExchangeableQuantity(
    $productId: ID!
    $type: OrderPurchaseType
    $isIncludeCurrentOrder: Boolean
  ) {
    getExchangeableQuantity(
      productId: $productId
      type: $type
      isIncludeCurrentOrder: $isIncludeCurrentOrder
    )
  }
`;
